import { config } from 'config';
import { User } from 'types';
import jwt_decode from 'jwt-decode';
import * as Sentry from '@sentry/react';

export const getCookie = (name: string): string => {
  return Object.fromEntries(
    document.cookie.split(/; */).map(c => {
      const [key, ...v] = c.split('=');
      return [key, decodeURIComponent(v.join('='))];
    }),
  )[name];
};

export const setCookie = (
  name: string,
  value?: string,
  options: { [k: string]: string } = {
    domain:
      process.env.NODE_ENV === 'development' || JSON.parse(process.env.REACT_APP_CI || 'false')
        ? ''
        : config.COOKIE_DOMAIN,
    path: '/',
  },
): void => {
  document.cookie = [`${name}=${value ? value : ''}`]
    .concat(Object.keys(options).map(k => `${k}=${options[k]}`))
    .join('; ');
};

export const deleteCookie = (
  name: string,
  options: { [k: string]: string } = {
    domain: process.env.NODE_ENV === 'development' ? '' : config.COOKIE_DOMAIN,
    path: '/',
  },
): void => {
  if (getCookie(name)) {
    document.cookie = [`${name}=; Thu, 01 Jan 1970 00:00:01 GMT`]
      .concat(Object.keys(options).map(k => `${k}=${options[k]}`))
      .join('; ');
  }
};

export const extractUserData = (token: string): User | undefined => {
  try {
    const UMData = jwt_decode(token) as any;
    return {
      firstName: UMData.firstName,
      lastName: UMData.lastName,
      userCorrelationId: UMData.user_correlation_id,
      email: UMData.email,
      id: UMData.id,
      username: UMData.username,
      isPro: !!UMData.authorizations.statements.find((s: { sid: string }) => s.sid === 'ROLE_PRO'),
      site: UMData.site,
      isCollaborator: !!UMData.collaborator,
    };
  } catch (e) {
    Sentry.captureException(e);
    return undefined;
  }
};

export const isTestUser = (email: string): boolean => {
  const domain = email.split('@').pop();
  return domain === 'carboatmedia.fr' || domain === 'lacentrale.fr';
};
